module.exports = __webpack_public_path__ + "static/media/full_screen.503c87a3.svg";